export interface SynthQuestion {
  id: string;
  text: string;
  options?: { id: string; text: string }[];
  correctOptionId?: string;
  comments?: string;
}

export function sanitizeFront(text: string): string {
  if (!text) return "";
  return text.replace(/\s+/g, " ").replace(/<[\s\S]*?>/g, "").trim();
}

export function sanitizeBack(question: SynthQuestion): string {
  const correct = question.options?.find((o) => o.id === question.correctOptionId);
  const parts: string[] = [];
  if (correct?.text) parts.push(`Resposta: ${correct.text}`);
  if (question.comments) parts.push(question.comments);
  return parts
    .join(" \n\n ")
    .replace(/\s+/g, " ")
    .replace(/<[\s\S]*?>/g, "")
    .trim();
}

// Placeholder para futura IA de condensação, se necessário
export async function synthesizeCard(question: Question) {
  return {
    front: sanitizeFront(question.text),
    back: sanitizeBack(question),
  };
}
